/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';



/**
 * V1 Data Migration (Admin Only)
 */
@Injectable({
  providedIn: 'root',
})
export class MigrationService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation validateMigration
   */
  static readonly ValidateMigrationPath = '/v1/migration/validate';

  /**
   * Validate migration readiness for current tenant.
   *
   * Runs pre-migration validation checks without executing the migration. Use this to identify potential issues before starting migration.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `validateMigration()` instead.
   *
   * This method doesn't expect any request body.
   */
  validateMigration$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, MigrationService.ValidateMigrationPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Validate migration readiness for current tenant.
   *
   * Runs pre-migration validation checks without executing the migration. Use this to identify potential issues before starting migration.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `validateMigration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  validateMigration(params?: {
  },
  context?: HttpContext

): Observable<void> {

    return this.validateMigration$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation executeUserExternalIdBackfill
   */
  static readonly ExecuteUserExternalIdBackfillPath = '/v1/migration/user-external-id/execute';

  /**
   * Backfill User.externalId from Cognito identities (async).
   *
   * Starts an asynchronous job for the authenticated tenant that sets externalId on SSO-domain users that do not have one yet, derived from their Cognito identities. Users without a linked identity are skipped. Users Cognito kept throttling, or whose externalId is already held by another user, are listed as failed in the job result. The job is idempotent, so it can be run again to pick up the throttled ones. Returns immediately with job ID (202 Accepted). Poll /jobs/{jobId} to check progress.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `executeUserExternalIdBackfill()` instead.
   *
   * This method doesn't expect any request body.
   */
  executeUserExternalIdBackfill$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, MigrationService.ExecuteUserExternalIdBackfillPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Backfill User.externalId from Cognito identities (async).
   *
   * Starts an asynchronous job for the authenticated tenant that sets externalId on SSO-domain users that do not have one yet, derived from their Cognito identities. Users without a linked identity are skipped. Users Cognito kept throttling, or whose externalId is already held by another user, are listed as failed in the job result. The job is idempotent, so it can be run again to pick up the throttled ones. Returns immediately with job ID (202 Accepted). Poll /jobs/{jobId} to check progress.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `executeUserExternalIdBackfill$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  executeUserExternalIdBackfill(params?: {
  },
  context?: HttpContext

): Observable<void> {

    return this.executeUserExternalIdBackfill$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation rollbackSectionBasedMigration
   */
  static readonly RollbackSectionBasedMigrationPath = '/v1/migration/section-based/rollback';

  /**
   * Roll back section-based migration (async).
   *
   * Starts an asynchronous rollback of the section-based migration for the authenticated tenant. Deletes all FormApprovalConfigV1 documents and strips section-based approval assignments from in-flight requests. The sectionsByType backfill on FormV1 is not reversed as it is a harmless computed field. Requires maintenance mode to be enabled. Requires confirmation parameter for safety. Returns immediately with job ID (202 Accepted). Poll /jobs/{jobId} to check status.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rollbackSectionBasedMigration()` instead.
   *
   * This method doesn't expect any request body.
   */
  rollbackSectionBasedMigration$Response(params: {
    confirm: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, MigrationService.RollbackSectionBasedMigrationPath, 'post');
    if (params) {
      rb.query('confirm', params.confirm, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Roll back section-based migration (async).
   *
   * Starts an asynchronous rollback of the section-based migration for the authenticated tenant. Deletes all FormApprovalConfigV1 documents and strips section-based approval assignments from in-flight requests. The sectionsByType backfill on FormV1 is not reversed as it is a harmless computed field. Requires maintenance mode to be enabled. Requires confirmation parameter for safety. Returns immediately with job ID (202 Accepted). Poll /jobs/{jobId} to check status.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `rollbackSectionBasedMigration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rollbackSectionBasedMigration(params: {
    confirm: string;
  },
  context?: HttpContext

): Observable<void> {

    return this.rollbackSectionBasedMigration$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation executeSectionBasedMigration
   */
  static readonly ExecuteSectionBasedMigrationPath = '/v1/migration/section-based/execute';

  /**
   * Migrate ApprovalV1 to FormApprovalConfigV1 (async).
   *
   * Starts an asynchronous section-based review migration for the authenticated tenant. Step 1: backfills sectionsByType on FormV1 documents missing the field. Step 2: creates FormApprovalConfigV1 from ApprovalV1 records, stripping conditions and adding all stage approvers as defaults per section. Step 3: assigns section approvers to in-flight requests that lack them. Forms whose configs land in SETUP_REQUIRED are listed as warnings in the job result. Requires maintenance mode to be enabled. Returns immediately with job ID (202 Accepted). Poll /jobs/{jobId} to check progress.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `executeSectionBasedMigration()` instead.
   *
   * This method doesn't expect any request body.
   */
  executeSectionBasedMigration$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, MigrationService.ExecuteSectionBasedMigrationPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Migrate ApprovalV1 to FormApprovalConfigV1 (async).
   *
   * Starts an asynchronous section-based review migration for the authenticated tenant. Step 1: backfills sectionsByType on FormV1 documents missing the field. Step 2: creates FormApprovalConfigV1 from ApprovalV1 records, stripping conditions and adding all stage approvers as defaults per section. Step 3: assigns section approvers to in-flight requests that lack them. Forms whose configs land in SETUP_REQUIRED are listed as warnings in the job result. Requires maintenance mode to be enabled. Returns immediately with job ID (202 Accepted). Poll /jobs/{jobId} to check progress.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `executeSectionBasedMigration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  executeSectionBasedMigration(params?: {
  },
  context?: HttpContext

): Observable<void> {

    return this.executeSectionBasedMigration$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation executeSectionBasedDryRun
   */
  static readonly ExecuteSectionBasedDryRunPath = '/v1/migration/section-based/dry-run';

  /**
   * Preview section-based migration without writing (async).
   *
   * Starts an asynchronous dry-run of the section-based migration. Performs all read operations and returns a preview of what the migration would do: how many configs would be created or skipped, and which forms would land in SETUP_REQUIRED. No data is written. Returns immediately with job ID (202 Accepted). Poll /jobs/{jobId} to check progress.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `executeSectionBasedDryRun()` instead.
   *
   * This method doesn't expect any request body.
   */
  executeSectionBasedDryRun$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, MigrationService.ExecuteSectionBasedDryRunPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Preview section-based migration without writing (async).
   *
   * Starts an asynchronous dry-run of the section-based migration. Performs all read operations and returns a preview of what the migration would do: how many configs would be created or skipped, and which forms would land in SETUP_REQUIRED. No data is written. Returns immediately with job ID (202 Accepted). Poll /jobs/{jobId} to check progress.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `executeSectionBasedDryRun$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  executeSectionBasedDryRun(params?: {
  },
  context?: HttpContext

): Observable<void> {

    return this.executeSectionBasedDryRun$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation rollbackMigration
   */
  static readonly RollbackMigrationPath = '/v1/migration/rollback';

  /**
   * Start async rollback to delete all V1 data for current tenant.
   *
   * Starts an asynchronous rollback job that physically deletes all V1 entities (FormV1, ApprovalV1, SupplierV1, SupplierRequestV1, NotificationEventV1) for the authenticated tenant. Use this to clean up V1 containers before re-running migration. Returns immediately with job ID (202 Accepted). Poll /jobs/{jobId} to check status. Requires confirmation parameter for safety.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rollbackMigration()` instead.
   *
   * This method doesn't expect any request body.
   */
  rollbackMigration$Response(params: {
    confirm: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, MigrationService.RollbackMigrationPath, 'post');
    if (params) {
      rb.query('confirm', params.confirm, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Start async rollback to delete all V1 data for current tenant.
   *
   * Starts an asynchronous rollback job that physically deletes all V1 entities (FormV1, ApprovalV1, SupplierV1, SupplierRequestV1, NotificationEventV1) for the authenticated tenant. Use this to clean up V1 containers before re-running migration. Returns immediately with job ID (202 Accepted). Poll /jobs/{jobId} to check status. Requires confirmation parameter for safety.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `rollbackMigration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rollbackMigration(params: {
    confirm: string;
  },
  context?: HttpContext

): Observable<void> {

    return this.rollbackMigration$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation executeMigration
   */
  static readonly ExecuteMigrationPath = '/v1/migration/execute';

  /**
   * Start V1 migration for current tenant (async).
   *
   * Starts an asynchronous migration job for the authenticated tenant. Returns immediately with 202 Accepted and a job ID. Poll /jobs/{jobId} to check progress.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `executeMigration()` instead.
   *
   * This method doesn't expect any request body.
   */
  executeMigration$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, MigrationService.ExecuteMigrationPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Start V1 migration for current tenant (async).
   *
   * Starts an asynchronous migration job for the authenticated tenant. Returns immediately with 202 Accepted and a job ID. Poll /jobs/{jobId} to check progress.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `executeMigration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  executeMigration(params?: {
  },
  context?: HttpContext

): Observable<void> {

    return this.executeMigration$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation fixApprovalTimestamps
   */
  static readonly FixApprovalTimestampsPath = '/v1/migration/data-fix/approval-timestamps';

  /**
   * Fix missing updatedAt fields in approval timestamps (async).
   *
   * Starts an asynchronous data fix job that populates missing updatedAt fields in SupplierRequestCaseApprovalV1 entities. This is needed for tenants where migration was run before the updatedAt field was added to the V1 approval entity. For approvals where updatedAt is null, it sets updatedAt = createdAt. Returns immediately with job ID (202 Accepted). Poll /jobs/{jobId} to check status.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fixApprovalTimestamps()` instead.
   *
   * This method doesn't expect any request body.
   */
  fixApprovalTimestamps$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, MigrationService.FixApprovalTimestampsPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Fix missing updatedAt fields in approval timestamps (async).
   *
   * Starts an asynchronous data fix job that populates missing updatedAt fields in SupplierRequestCaseApprovalV1 entities. This is needed for tenants where migration was run before the updatedAt field was added to the V1 approval entity. For approvals where updatedAt is null, it sets updatedAt = createdAt. Returns immediately with job ID (202 Accepted). Poll /jobs/{jobId} to check status.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `fixApprovalTimestamps$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fixApprovalTimestamps(params?: {
  },
  context?: HttpContext

): Observable<void> {

    return this.fixApprovalTimestamps$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation listMigrationJobs
   */
  static readonly ListMigrationJobsPath = '/v1/migration/jobs';

  /**
   * List migration jobs for current tenant.
   *
   * Returns all migration jobs for the authenticated tenant, optionally filtered by status. Jobs are sorted by creation date (newest first).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listMigrationJobs()` instead.
   *
   * This method doesn't expect any request body.
   */
  listMigrationJobs$Response(params?: {
    status?: 'QUEUED' | 'RUNNING' | 'COMPLETED' | 'FAILED';
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, MigrationService.ListMigrationJobsPath, 'get');
    if (params) {
      rb.query('status', params.status, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * List migration jobs for current tenant.
   *
   * Returns all migration jobs for the authenticated tenant, optionally filtered by status. Jobs are sorted by creation date (newest first).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listMigrationJobs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listMigrationJobs(params?: {
    status?: 'QUEUED' | 'RUNNING' | 'COMPLETED' | 'FAILED';
  },
  context?: HttpContext

): Observable<void> {

    return this.listMigrationJobs$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation getMigrationJobStatus
   */
  static readonly GetMigrationJobStatusPath = '/v1/migration/jobs/{jobId}';

  /**
   * Get migration job status.
   *
   * Poll this endpoint to check migration progress. Returns job status, progress percentage, and results when completed.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMigrationJobStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMigrationJobStatus$Response(params: {
    jobId: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, MigrationService.GetMigrationJobStatusPath, 'get');
    if (params) {
      rb.path('jobId', params.jobId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Get migration job status.
   *
   * Poll this endpoint to check migration progress. Returns job status, progress percentage, and results when completed.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMigrationJobStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMigrationJobStatus(params: {
    jobId: string;
  },
  context?: HttpContext

): Observable<void> {

    return this.getMigrationJobStatus$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
